import PropTypes from 'prop-types';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectPropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { CurrentOwnerContext, TimelinePermissionsContext } from 'crm-events-data';
import PartnerSharedActivitiesContainerAsync from './PartnerSharedActivitiesContainerAsync';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerSharedActivitiesTab = ({
  scopes,
  subject,
  objectType
}) => {
  return /*#__PURE__*/_jsx(TimelinePermissionsContext.Consumer, {
    children: permissions => /*#__PURE__*/_jsx(CurrentOwnerContext.Consumer, {
      children: owner => /*#__PURE__*/_jsx(PartnerSharedActivitiesContainerAsync, {
        objectType: objectType,
        owner: owner,
        permissions: permissions,
        subject: subject,
        userScopes: scopes
      })
    })
  });
};
PartnerSharedActivitiesTab.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired,
  scopes: PropTypes.arrayOf(PropTypes.string),
  subject: AnyCrmObjectPropType.isRequired
};
export default PartnerSharedActivitiesTab;